import { Timer } from 'lucide-react'
import { useEffect, useState } from 'react'

const pad = (n: number) => String(n).padStart(2, '0')

/** Elapsed time as «чч:мм:сс». */
function formatElapsed(ms: number) {
	const total = Math.max(0, Math.floor(ms / 1000))
	return `${pad(Math.floor(total / 3600))}:${pad(Math.floor(total / 60) % 60)}:${pad(total % 60)}`
}

/**
 * How long ago `since` (epoch ms) was, ticking every second. Counted from the clock,
 * not from the ticks, so a throttled background tab still shows the right time.
 */
export function Stopwatch({ since, testId }: { since: number; testId?: string }) {
	const [now, setNow] = useState(() => Date.now())
	useEffect(() => {
		const id = setInterval(() => setNow(Date.now()), 1000)
		return () => clearInterval(id)
	}, [])
	return (
		<span className='inline-flex items-center gap-1 font-mono tabular-nums' data-testid={testId}>
			<Timer className='size-3.5' aria-hidden />
			{formatElapsed(now - since)}
		</span>
	)
}
